








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { TicketCollectionModel, TicketCollectionWithModel } from '@/modules/ticket/models/ticket-collection.model'
import { AdminTicketRoute } from '@/modules/ticket/routes/admin-ticket.route'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminTicketActions extends Vue {

  constructor(
    private readonly routes: AdminTicketRoute
  ) {
    super()
  }

  @Prop() ticket!: TicketCollectionModel
  @Prop() withData!: TicketCollectionWithModel

}

